export default [
  {
    path: '/andersen/alive/:andersenNo',
    component: () => import('@/views/andersen/alive/AndersenAliveList.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '생전 모습'
    }
  },
  {
    path: '/andersen/alive/form/:andersenNo',
    component: () => import('@/views/andersen/alive/AndersenAliveForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '생전모습 등록하기'
    }
  },
  {
    path: '/andersen/alive/form/update/:aliveNo',
    component: () => import('@/views/andersen/alive/AndersenAliveForm.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '생전모습 수정하기'
    }
  },
  {
    path: '/andersen/alive/detail/:aliveNo',
    component: () => import('@/views/andersen/alive/AndersenAliveDetail.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '생전 모습'
    }
  },

  {
    path: '/andersen/home/:andersenNo',
    component: () => import('@/views/andersen/AndersenHome.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '안데르센관 상세'
    }
  },

  {
    path: '/andersen/:andersenNo',
    component: () => import('@/views/andersen/AndersenDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isGlass: true,
      isSearchHeader: false
    }
  },

  {
    path: '/andersen/comment/:andersenNo',
    component: () => import('@/views/andersen/AndersenComment.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '헌화하기',
      isGlass: false
    }
  },

  {
    path: '/andersen/form/info',
    component: () => import('@/views/andersen/form/Step1_Form.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '안데르센관 만들기'
    }
  },

  {
    path: '/andersen/form/info/:andersenNo',
    component: () => import('@/views/andersen/form/Step1_Form.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '안데르센관 수정하기'
    }
  },

  {
    path: '/andersen/form/anniversary',
    component: () => import('@/views/andersen/form/Step2_Alert.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '안데르센관 만들기'
    }
  },

  {
    path: '/andersen/form/anniversary/:andersenNo',
    component: () => import('@/views/andersen/form/Step2_Alert.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '안데르센관 만들기'
    }
  },

  {
    path: '/andersen/form/background',
    component: () => import('@/views/andersen/form/Step3_Background.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '안데르센관 만들기'
    }
  },
  {
    path: '/andersen/form/background/:andersenNo',
    component: () => import('@/views/andersen/form/Step3_Background.vue'),
    meta: {
      isHeader: true,
      isHome: true,
      isNav: false,
      isBack: true,
      titleName: '안데르센관 만들기'
    }
  }
];
